import { ACCESS_PROFILES } from '@/const'

export function permissionAccess(perfilUser) {
  const permissionAccess = new Set()
  if(perfilUser.some((el) => el.name.includes('stic'))) {
    for(const access of ACCESS_PROFILES['stic']) {
      permissionAccess.add(access)
    }
  }
  if(perfilUser.some((el) => el.name.includes('corregedorGeral'))) permissionAccess.add(ACCESS_PROFILES['corregedorGeral'])
  if(perfilUser.some((el) => el.name.includes('corregedorAdjunto'))) permissionAccess.add(ACCESS_PROFILES['corregedorAdjunto'])
  if(perfilUser.some((el) => el.name.includes('divpol.chefia'))) permissionAccess.add(ACCESS_PROFILES['divpol.chefia'])
  if(perfilUser.some((el) => el.name.includes('divpol.spessoal'))) permissionAccess.add(ACCESS_PROFILES['divpol.spessoal'])
  if(perfilUser.some((el) => el.name.includes('chefia'))) permissionAccess.add(ACCESS_PROFILES['chefia'])
  return permissionAccess.size > 0 ? permissionAccess : null
}